/**
 * `MailSig` — the demo's `mailSig(org)` (demo line 1493): the organisation
 * line under an email, behind a dashed rule.
 *
 * The OEM's own signature follows the selected brand and carries its logo;
 * a customer organisation's stays the fictional one from the data pack. An
 * organisation the pack does not know falls back to the OEM, as the demo did.
 * UI layer.
 */

import { customerSignatureLine, DATA_OEM_ORG, oemSignatureLine } from './doc-identity';
import { OemLogo } from './OemLogo';
import { useOemDocIdentity } from './useOemDocIdentity';

export function MailSig({ org = DATA_OEM_ORG }: { org?: string }) {
  const oem = useOemDocIdentity();
  const customer = org === DATA_OEM_ORG ? null : customerSignatureLine(org);
  return (
    <div
      className="mailsig mt-2.5 flex items-center gap-2.5 border-t border-dashed pt-2 text-[11.5px]"
      style={{ borderColor: 'var(--hairline)', color: 'var(--ink-tertiary)' }}
    >
      {customer ? null : <OemLogo height={14} />}
      <span>{customer ?? oemSignatureLine(oem)}</span>
    </div>
  );
}
